module.exports = __webpack_public_path__ + "img/8009_1.8f544fab.gif";